$(document).ready(function () {
  // Only run on create account page
  if(!$(".create-account").length > 0) {
    return ;
  }
});
